import UserAmountEditHistory from './UserAmountEditHistory';

export default UserAmountEditHistory;
